import React, { useEffect } from "react";
import ReportVocEmissionTable from "./component/ReportVocEmissionTable";
import { useSearchParams } from "react-router-dom";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";

let isRequestCompany: string | null = null;
const TMReportVocEmission = () => {
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");
  const profile = profileStore(useShallow((state) => state.profile));
  const requestProfile = profileStore(useShallow((state) => state.requestProfile));

  useEffect(() => {
    if (profile?.company && profile.company.length > 0 && companyId && (!isRequestCompany || isRequestCompany != companyId)) {
      const findSlot = profile.company.find((item) => item._id == companyId);
      if (findSlot) {
        requestProfile({ companyId: companyId });
        isRequestCompany = companyId;
      } else {
        window.location.pathname = "/unauthorized";
      }
    }
  }, [profile?.company]);

  return <ReportVocEmissionTable />;
};

export default TMReportVocEmission;
